// extracted by mini-css-extract-plugin
export default {"dialogProviderContainer":"_dialog-provider_dialogProviderContainer__WaMaN"};